import { Helmet } from 'react-helmet-async';

interface OrganizationStructuredData {
  "@context": "https://schema.org";
  "@type": "Organization";
  name: string;
  description: string;
  url: string;
  logo: string;
  sameAs: string[];
}

interface WebsiteStructuredData {
  "@context": "https://schema.org";
  "@type": "WebSite";
  name: string;
  url: string;
}

const organizationData: OrganizationStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "RentFi",
  "description": "RentFi enables anyone to invest in premium real estate properties and earn monthly passive income through blockchain technology.",
  "url": "https://rentfi.io",
  "logo": "https://i.postimg.cc/hPNFtcr4/rentfi-logo.png",
  "sameAs": [
  "https://rentfi.crunch.help/",
  "https://rentfi.medium.com/",
  "https://merch.rentfi.io/",
  "https://x.com/RentFi_io",
  "https://linkedin.com/company/rentfi-io",
  "https://pinterest.com/rentfi/",
  "https://youtube.com/@RentFi",
  "https://instagram.com/rentfi_io",
  "https://tiktok.com/@rentfi_io",
  "https://zealy.io/c/rentfi",
  "https://t.me/rentfi_io",
  "https://trustpilot.com/review/rentfi.io"
  ]
};

const websiteData: WebsiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "RentFi",
  "url": "https://rentfi.io"
};

export default function StructuredData() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
    </Helmet>
  );
}